import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export const Article = ({
  height
}) => /*#__PURE__*/React.createElement(S.Icon, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  height: height,
  "aria-label": "artikel"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3,4 L19,4 L19,7 L3,7 L3,4 Z M3,10 L21,10 L21,13 L3,13 L3,10 Z M3,16 L17,16 L17,19 L3,19 L3,16 Z"
}));
Article.propTypes = {
  height: PropTypes.string
};
Article.defaultProps = {
  height: '25px'
};